var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentOptionRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.73477 8.62179L2.40132 15.7424C2.04764 16.0859 1.47423 16.0859 1.12058 15.7424L0.265254 14.9119C-0.087826 14.5691 -0.0885055 14.0134 0.263745 13.6698L6.07563 7.99998L0.263744 2.33019C-0.0885061 1.98655 -0.0878265 1.43091 0.265254 1.08808L1.12058 0.257567C1.47426 -0.0858555 2.04767 -0.0858556 2.40132 0.257567L9.73477 7.37817C10.0884 7.72159 10.0884 8.27837 9.73477 8.62179Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentOptionRightArrow);
export default __webpack_public_path__ + "static/media/payment-option-right-arrow.79d4d80787338c35dab63bb2d8b30f37.svg";
export { ForwardRef as ReactComponent };